import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { Button } from './ui/button';
import { Check, MapPin } from 'lucide-react';

const LONDON_BOROUGHS = [
  { id: 'city',         name: 'City of London',        label: 'EC',  lx: 262, ly: 191, postcodes: ['EC1','EC2','EC3','EC4'],                                        path: 'M248,185 L265,175 L280,185 L275,200 L255,205 L248,195 Z' },
  { id: 'westminster', name: 'Westminster',             label: 'W1',  lx: 222, ly: 208, postcodes: ['SW1','W1','WC1','WC2'],                                         path: 'M200,185 L248,185 L248,195 L255,205 L245,230 L210,235 L190,210 Z' },
  { id: 'kensington',  name: 'Kensington & Chelsea',   label: 'W8',  lx: 166, ly: 230, postcodes: ['SW3','SW5','SW7','SW10','W8','W11','W14'],                       path: 'M150,195 L190,195 L190,210 L210,235 L195,265 L140,260 L140,210 Z' },
  { id: 'hammersmith', name: 'Hammersmith & Fulham',   label: 'W6',  lx: 112, ly: 262, postcodes: ['SW6','W6','W12'],                                               path: 'M100,220 L140,210 L140,260 L145,310 L95,305 L85,250 Z' },
  { id: 'wandsworth',  name: 'Wandsworth',             label: 'SW',  lx: 186, ly: 318, postcodes: ['SW11','SW12','SW15','SW17','SW18','SW19'],                       path: 'M145,310 L195,265 L230,290 L240,340 L180,355 L140,340 Z' },
  { id: 'lambeth',     name: 'Lambeth',                label: 'SW',  lx: 258, ly: 318, postcodes: ['SE1','SE5','SE11','SE24','SE27','SW2','SW4','SW8','SW9'],        path: 'M230,290 L275,275 L295,310 L285,360 L240,340 Z' },
  { id: 'southwark',   name: 'Southwark',              label: 'SE1', lx: 303, ly: 255, postcodes: ['SE1','SE5','SE15','SE16','SE17','SE21','SE22'],                  path: 'M275,205 L320,200 L340,240 L330,290 L295,310 L275,275 Z' },
  { id: 'tower_hamlets', name: 'Tower Hamlets',        label: 'E14', lx: 323, ly: 194, postcodes: ['E1','E2','E3','E14'],                                           path: 'M280,185 L320,170 L360,190 L350,230 L320,200 L275,200 Z' },
  { id: 'hackney',     name: 'Hackney',                label: 'E8',  lx: 296, ly: 158, postcodes: ['E5','E8','E9','N1','N16'],                                      path: 'M265,140 L310,125 L340,150 L320,170 L280,185 L265,175 Z' },
  { id: 'islington',   name: 'Islington',              label: 'N1',  lx: 249, ly: 164, postcodes: ['EC1','N1','N4','N5','N7'],                                      path: 'M240,145 L265,140 L265,175 L248,185 L230,170 Z' },
  { id: 'camden',      name: 'Camden',                 label: 'NW1', lx: 216, ly: 158, postcodes: ['NW1','NW3','NW5','WC1','WC2'],                                  path: 'M200,130 L240,125 L240,145 L230,170 L248,185 L200,185 L185,155 Z' },
  { id: 'brent',       name: 'Brent',                  label: 'NW',  lx: 158, ly: 138, postcodes: ['HA0','HA9','NW2','NW6','NW10'],                                 path: 'M130,115 L185,105 L200,130 L185,155 L150,165 L115,145 Z' },
  { id: 'ealing',      name: 'Ealing',                 label: 'W5',  lx: 80,  ly: 137, postcodes: ['UB1','UB2','UB5','UB6','W3','W5','W7','W13'],                   path: 'M50,160 L115,145 L130,115 L80,110 L40,145 Z' },
  { id: 'hounslow',    name: 'Hounslow',               label: 'TW',  lx: 46,  ly: 218, postcodes: ['TW3','TW4','TW5','TW7','TW8','TW13','TW14','W4'],               path: 'M20,200 L50,160 L85,180 L85,250 L40,270 L10,250 Z' },
  { id: 'richmond',    name: 'Richmond upon Thames',   label: 'TW',  lx: 55,  ly: 308, postcodes: ['KT1','SW14','TW1','TW2','TW9','TW10','TW11','TW12'],            path: 'M40,270 L85,250 L95,305 L90,355 L30,360 L20,310 Z' },
  { id: 'kingston',    name: 'Kingston upon Thames',   label: 'KT',  lx: 112, ly: 382, postcodes: ['KT1','KT2','KT3','KT4','KT5'],                                  path: 'M90,355 L140,340 L155,390 L120,420 L70,400 Z' },
  { id: 'merton',      name: 'Merton',                 label: 'SW',  lx: 168, ly: 373, postcodes: ['CR4','SM4','SW19','SW20'],                                      path: 'M140,340 L180,355 L200,400 L155,390 Z' },
  { id: 'sutton',      name: 'Sutton',                 label: 'SM',  lx: 172, ly: 426, postcodes: ['KT4','SM1','SM2','SM3','SM5','SM6'],                            path: 'M155,390 L200,400 L230,450 L170,460 L120,420 Z' },
  { id: 'croydon',     name: 'Croydon',                label: 'CR',  lx: 248, ly: 428, postcodes: ['CR0','CR2','CR4','CR7','CR8','SE25'],                           path: 'M200,400 L250,380 L290,420 L280,480 L230,450 Z' },
  { id: 'bromley',     name: 'Bromley',                label: 'BR',  lx: 338, ly: 444, postcodes: ['BR1','BR2','BR3','BR4','BR5','BR6','BR7','SE6','SE9','SE20'],    path: 'M290,420 L350,390 L400,430 L380,490 L280,480 Z' },
  { id: 'lewisham',    name: 'Lewisham',               label: 'SE',  lx: 322, ly: 334, postcodes: ['SE4','SE6','SE8','SE12','SE13','SE14','SE23'],                  path: 'M295,310 L330,290 L355,330 L340,370 L300,360 Z' },
  { id: 'greenwich',   name: 'Greenwich',              label: 'SE',  lx: 362, ly: 287, postcodes: ['SE3','SE7','SE9','SE10','SE12','SE18','SE28'],                  path: 'M340,240 L390,235 L400,290 L370,330 L355,330 L330,290 Z' },
  { id: 'bexley',      name: 'Bexley',                 label: 'DA',  lx: 424, ly: 279, postcodes: ['DA1','DA5','DA6','DA7','DA8','DA14','DA15','DA16','DA17','SE2'], path: 'M390,235 L450,230 L460,290 L430,340 L400,290 Z' },
  { id: 'newham',      name: 'Newham',                 label: 'E',   lx: 372, ly: 214, postcodes: ['E6','E7','E12','E13','E15','E16'],                              path: 'M350,230 L390,235 L400,200 L360,190 Z' },
  { id: 'barking',     name: 'Barking & Dagenham',     label: 'RM',  lx: 426, ly: 216, postcodes: ['IG11','RM6','RM7','RM8','RM9','RM10'],                          path: 'M400,200 L450,190 L460,230 L430,240 L390,235 Z' },
  { id: 'redbridge',   name: 'Redbridge',              label: 'IG',  lx: 403, ly: 170, postcodes: ['E11','E12','E18','IG1','IG2','IG3','IG4','IG5','IG6'],          path: 'M360,145 L410,130 L450,160 L450,190 L400,200 L360,190 Z' },
  { id: 'havering',    name: 'Havering',               label: 'RM',  lx: 483, ly: 177, postcodes: ['RM1','RM2','RM3','RM4','RM5','RM6','RM11','RM12','RM13','RM14'],path: 'M450,130 L510,120 L530,180 L500,230 L460,230 L450,160 Z' },
  { id: 'waltham',     name: 'Waltham Forest',         label: 'E',   lx: 344, ly: 128, postcodes: ['E4','E10','E11','E17'],                                         path: 'M320,110 L360,100 L380,130 L360,145 L340,150 L310,125 Z' },
  { id: 'haringey',    name: 'Haringey',               label: 'N',   lx: 284, ly: 113, postcodes: ['N4','N6','N8','N10','N11','N15','N17','N22'],                   path: 'M265,95 L310,85 L320,110 L310,125 L265,140 L245,115 Z' },
  { id: 'enfield',     name: 'Enfield',                label: 'EN',  lx: 300, ly: 78,  postcodes: ['EN1','EN2','EN3','N9','N11','N13','N14','N18','N21'],           path: 'M265,50 L340,40 L360,100 L320,110 L310,85 L265,95 L250,65 Z' },
  { id: 'barnet',      name: 'Barnet',                 label: 'N',   lx: 210, ly: 92,  postcodes: ['EN4','EN5','N2','N3','N6','N10','N11','N12','N14','NW4','NW7','NW9','NW11'], path: 'M175,55 L250,45 L265,95 L245,115 L200,130 L185,105 L160,90 Z' },
  { id: 'harrow',      name: 'Harrow',                 label: 'HA',  lx: 132, ly: 89,  postcodes: ['HA0','HA1','HA2','HA3','HA5','HA7','HA8'],                      path: 'M100,80 L160,70 L175,55 L160,90 L130,115 L80,110 Z' },
];

export const LondonMap = () => {
  const [hoveredBorough, setHoveredBorough] = useState(null);
  const [selectedBorough, setSelectedBorough] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const navigate = useNavigate();

  const handleBoroughClick = (borough) => {
    setSelectedBorough(borough);
    setDialogOpen(true);
  };

  return (
    <section id="coverage" className="py-12 md:py-20 lg:py-32 bg-slate-50" data-testid="coverage-section">
      <div className="container mx-auto px-6 md:px-12 lg:px-24">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="text-teal font-semibold text-sm uppercase tracking-wider">Service Area</span>
          <h2 className="font-heading text-4xl md:text-5xl font-semibold text-navy mt-3 mb-4">
            We Cover All of London
          </h2>
          <p className="text-slate-600 text-lg max-w-2xl mx-auto">
            Click on your borough to confirm our availability in your area. We service all 32 London boroughs.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="relative max-w-4xl mx-auto"
        >
          <div className="bg-white rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.08)] p-2 sm:p-6 md:p-12">
            <svg
              viewBox="0 0 550 520"
              className="w-full h-auto"
              data-testid="london-map-svg"
            >
              {LONDON_BOROUGHS.map((borough) => (
                <motion.path
                  key={borough.id}
                  d={borough.path}
                  fill={hoveredBorough === borough.id ? '#2dd4bf' : '#e2e8f0'}
                  stroke="#1a2b4a"
                  strokeWidth="1.5"
                  className="cursor-pointer"
                  data-testid={`borough-${borough.id}`}
                  onMouseEnter={() => setHoveredBorough(borough.id)}
                  onMouseLeave={() => setHoveredBorough(null)}
                  onClick={() => handleBoroughClick(borough)}
                  whileHover={{ scale: 1.02 }}
                  style={{ transformOrigin: 'center', transition: 'fill 0.2s ease' }}
                />
              ))}
              {LONDON_BOROUGHS.map((borough) => (
                <text
                  key={`label-${borough.id}`}
                  x={borough.lx}
                  y={borough.ly}
                  textAnchor="middle"
                  dominantBaseline="middle"
                  fontSize="8"
                  fontWeight="700"
                  fill={hoveredBorough === borough.id ? '#1a2b4a' : '#475569'}
                  pointerEvents="none"
                  style={{ userSelect: 'none' }}
                >
                  {borough.label}
                </text>
              ))}
            </svg>

            {hoveredBorough && (
              <motion.div
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                className="absolute bottom-4 left-1/2 transform -translate-x-1/2 bg-navy text-white px-4 py-2 rounded-lg shadow-lg flex items-center gap-2"
              >
                <MapPin className="w-4 h-4 text-teal" />
                <span className="font-medium">
                  {LONDON_BOROUGHS.find(b => b.id === hoveredBorough)?.name}
                </span>
              </motion.div>
            )}
          </div>

          <div className="mt-8 flex flex-wrap justify-center gap-4">
            <div className="flex items-center gap-2 text-sm text-slate-600">
              <div className="w-4 h-4 bg-slate-200 rounded border border-navy"></div>
              <span>Service Area</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-slate-600">
              <div className="w-4 h-4 bg-teal rounded border border-navy"></div>
              <span>Hover/Selected</span>
            </div>
          </div>
        </motion.div>
      </div>

      <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
        <DialogContent className="sm:max-w-md" data-testid="borough-dialog">
          <DialogHeader>
            <DialogTitle className="font-heading text-2xl text-navy flex items-center gap-2">
              <Check className="w-6 h-6 text-teal" />
              {selectedBorough?.name}
            </DialogTitle>
            <DialogDescription className="text-slate-600 pt-2">
              We cover all of {selectedBorough?.name}. Our team serves every postcode in this borough.
            </DialogDescription>
          </DialogHeader>
          {selectedBorough?.postcodes && (
            <div className="mt-1">
              <p className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-2">Postcodes covered</p>
              <div className="flex flex-wrap gap-1.5">
                {selectedBorough.postcodes.map((pc) => (
                  <span key={pc} className="bg-teal/10 text-teal text-xs font-semibold px-2 py-1 rounded">
                    {pc}
                  </span>
                ))}
              </div>
            </div>
          )}
          <div className="flex flex-col gap-3 mt-4">
            <Button
              className="bg-gold hover:bg-gold-dark text-navy font-semibold"
              onClick={() => {
                setDialogOpen(false);
                navigate('/get-a-quote');
              }}
              data-testid="book-now-btn"
            >
              Get a Free Quote
            </Button>
            <Button 
              variant="outline" 
              className="border-navy text-navy hover:bg-navy hover:text-white"
              onClick={() => setDialogOpen(false)}
            >
              Continue Browsing
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </section>
  );
};
